import { Box, Grid, Typography } from "@material-ui/core";
import { InvestorHeader } from "../../InvestorCart";
import { AmcHeader, Disclaimer, SipSummaryItem } from "../../CartItems";

import { Form, Formik } from "formik";
import GridContainer from "../../../../../lib/GridContainer";
import FormSelect from "../../../../forms/formik/FormSelectField";
import SubmitButton from "../../../../forms/formik/FormSubmitButton";
import {
  useSipCart,
  useSipSingle,
  validationSchema,
} from "../useSip/useSipWithoutPayment";
import UmrnDetails from "../../../../common/umrn-details";
import { getDescriptiveDate } from "../../../../../utils/cart";
import { Fragment } from "react";

const NJ_MUTUAL_FUND_CODE = "187";

export function SipWithoutPaymentCart() {
  const {
    amcName,
    changleHandler,
    handleSubmit,
    initialValues,
    investorName,
    options,
    pan,
    selectedCartItems,
    oldCart,
  } = useSipCart();

  return (
    <Grid container>
      <Grid item lg={9} sm={12}>
        <InvestorHeader name={investorName} pan={pan} />

        <Box
          sx={{
            margin: "40px",
            bgcolor: "white",
            padding: "18px 24px 18px 24px",
            boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
            borderRadius: "4px",
            marginBottom: "120px",
          }}
        >
          <Typography
            component={"h4"}
            style={{
              fontWeight: "800",
              fontSize: "24px",
              marginBottom: "20px",
              fontFamily: "OpenSans-SemiBold",
            }}
          >
            SIP Purchase Without Payment
          </Typography>

          <AmcHeader amcName={amcName} />

          <Box
            sx={{
              padding: "10px",
              border: "0.5px solid #C7D2D4",
            }}
          >
            {oldCart.length !== 0 ? (
              <Fragment>
                {oldCart.map((sipItem) => {
                  const { payload, cartItemId } = sipItem;
                  const { sipStartDate, sipEndDate } = payload;
                  const cartItem = selectedCartItems.find(
                    (item) => item.cartItemId === cartItemId
                  );
                  const isDifferentDates =
                    new Date(sipStartDate).getTime() !==
                    new Date(cartItem.payload.sipStartDate).getTime();

                  const [d1, newD1, d2, newD2] = [
                    sipStartDate,
                    cartItem.payload.sipStartDate,
                    sipEndDate,
                    cartItem.payload.sipEndDate,
                  ]
                    .map(getDescriptiveDate)
                    .map((d) => <strong>{d}</strong>);

                  return (
                    <Fragment key={sipItem.cartItemId}>
                      <SipSummaryItem {...payload} />
                      {isDifferentDates && (
                        <Typography>
                          Your SIP Startdate have been changed from {d1} to{" "}
                          {newD1} and SIP Enddate have been changed from {d2} to{" "}
                          {newD2}
                        </Typography>
                      )}
                    </Fragment>
                  );
                })}
              </Fragment>
            ) : (
              <Fragment>
                {selectedCartItems.map((item) => (
                  <SipSummaryItem {...item.payload} key={item.ihno} />
                ))}
              </Fragment>
            )}
          </Box>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            enableReinitialize
            validationSchema={validationSchema}
          >
            {({ values, setValues }) => {
              const selectedUmrn = options.umrnOptions.find(
                (item) => item.value === values.umrn
              );
              return (
                <Form>
                  <GridContainer>
                    <Box>
                      <FormSelect
                        name="registration"
                        label="Mode of Registration (SIP)"
                        options={options.registrationModes}
                        onChange={changleHandler.handleRegistrationChange(
                          values,
                          setValues
                        )}
                      />
                      {selectedCartItems[0].fund === NJ_MUTUAL_FUND_CODE ? (
                        <Disclaimer disclaimer="The ISIP option is unavailable for NJ Mutual Fund" />
                      ) : null}
                    </Box>

                    {values.registration !== "ISIP" ? (
                      <FormSelect
                        name="umrn"
                        label="Select Mandate"
                        options={options.umrnOptions}
                        onChange={changleHandler.handleUmrnChange(
                          values,
                          setValues
                        )}
                      />
                    ) : null}
                  </GridContainer>
                  {values.umrn && values.umrn !== "createMandate" ? (
                    <UmrnDetails {...selectedUmrn} />
                  ) : null}

                  <SubmitButton label="Save and Proceed" variant="contained" />
                </Form>
              );
            }}
          </Formik>
        </Box>
      </Grid>
    </Grid>
  );
}

export function SipWithoutPaymentSingle() {
  const {
    amcName,
    changleHandler,
    handleSubmit,
    initialValues,
    investorName,
    options,
    pan,
    requestBody,
    updatedRequest,
  } = useSipSingle();

  return (
    <Box display="flex" flexDirection="column">
      <InvestorHeader name={investorName} pan={pan} />

      <Box
        sx={{
          margin: "40px",
          bgcolor: "white",
          padding: "18px 24px 18px 24px",
          boxShadow: "0px 0px 8px 0px rgba(202, 202, 202, 1);",
          borderRadius: "4px",
          marginBottom: "120px",
        }}
      >
        <Typography
          component={"h4"}
          style={{
            fontWeight: "800",
            fontSize: "24px",
            marginBottom: "20px",
            fontFamily: "OpenSans-SemiBold",
          }}
        >
          SIP Purchase Without Payment
        </Typography>

        <AmcHeader amcName={amcName} />

        <Box
          sx={{
            padding: "10px",
            border: "0.5px solid #C7D2D4",
          }}
        >
          {() => {
            if (updatedRequest) {
              const { oldEndDate, oldStartDate, ...rest } = updatedRequest;
              const isDifferentDates =
                new Date(oldEndDate).getTime() !==
                new Date(rest.sipStartDate).getTime();
              const [
                indianOldStartDate,
                indianOldEndDate,
                indianStartDate,
                indianEndDate,
              ] = [oldStartDate, oldEndDate, rest.sipStartDate, rest.sipEndDate]
                .map(getDescriptiveDate)
                .map((date) => <strong>{date}</strong>);

              return (
                <Fragment>
                  <SipSummaryItem {...rest} />
                  {isDifferentDates ? (
                    <Typography style={{ margin: "1rem" }}>
                      Your SIP Startdate have been changed from{" "}
                      {indianOldStartDate} to {indianStartDate} and SIP Enddate
                      have been changed from {indianOldEndDate} to{" "}
                      {indianEndDate}
                    </Typography>
                  ) : null}
                </Fragment>
              );
            }
            return <SipSummaryItem {...requestBody} />;
          }}
        </Box>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
          validationSchema={validationSchema}
        >
          {({ values, setValues }) => {
            const selectedUmrn = options.umrnOptions.find(
              ({ value }) => value === values.umrn
            );
            return (
              <Form>
                <GridContainer>
                  <Box>
                    <FormSelect
                      name="registration"
                      label="Mode of Registration (SIP)"
                      options={options.registrationModes}
                      onChange={changleHandler.handleRegistrationChange(
                        values,
                        setValues
                      )}
                    />
                    {requestBody.fund === NJ_MUTUAL_FUND_CODE ? (
                      <Disclaimer disclaimer="The ISIP option is unavailable for NJ Mutual Fund" />
                    ) : null}
                  </Box>
                  {values.registration !== "ISIP" ? (
                    <FormSelect
                      name="umrn"
                      label="Select Mandate"
                      options={options.umrnOptions}
                      onChange={changleHandler.handleUmrnChange(
                        values,
                        setValues
                      )}
                    />
                  ) : null}
                </GridContainer>
                {values.umrn && values.umrn !== "createMandate" ? (
                  <UmrnDetails {...selectedUmrn} />
                ) : null}
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <SubmitButton label="Save and Proceed" variant="contained" />
                </Box>
              </Form>
            );
          }}
        </Formik>
      </Box>
    </Box>
  );
}
